import { connect } from 'react-redux';
import DevelopmentDashboard from '../index';

const mapStateToProps = () => ({
  // Add state props here if needed
});

const mapDispatchToProps = () => ({
  // Add dispatch props here if needed
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DevelopmentDashboard);
